import { roundToCents } from "./mathUtils";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

/**
 * Clean a currency value by rounding to 2 decimal places (cents)
 * Uses decimal.js for precision to avoid floating-point errors
 * @param {number|string|null|undefined} value - Value to clean
 * @returns {number} Value rounded to 2 decimal places
 */
export const cleanCurrencyValue = value => roundToCents(value);

export default formatter;
